import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../AppContext';
import { useParams } from 'react-router-dom';
import QuickSightDashboard from '../../components/QuickSightDashboard/QuicksightDashboard';


const DashboardView = (props) => { 

    const { apiKey, availableDashboards, setMenuTitle, embedContext, realTime } = useContext(AppContext);

    const params = useParams();
    // const [dashboardId, setDashboardId] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0]?.key)
    // const [dashboardTitle, setDashboardTitle] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0]?.text)
    // const [dashboardType, setDashboardType] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0]?.type)

    const [selectedDashboard, setSelectedDashboard] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0])

    useEffect(() => {
        if(!!params?.dashboardId && availableDashboards?.length >0) {
            // console.log('availableDashboards: ', availableDashboards);
            const dashboard = availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0];
            setSelectedDashboard(dashboard)
            // setDashboardId(dashboard?.key);
            // setDashboardType(dashboard?.type);
            // !!dashboard?.text && setDashboardTitle(dashboard?.text);
            !!dashboard?.text && setMenuTitle(dashboard?.text);  
        }

    }, [params, availableDashboards])
    
    //eslint-disable-next-line
    let whatever = import.meta.env;

    return <QuickSightDashboard 
        key={selectedDashboard.key}
        dashboardId={selectedDashboard.key} 
        dashboardTitle={selectedDashboard.text}
        dashboardType={selectedDashboard.type}
        apiKey={apiKey}
        realTime={realTime}
        embedContext={embedContext}
        singleSheet={import.meta?.env?.VITE_HIDETABS ==="true" ? true : false}
    />
};

export default DashboardView;